import {
    createColumnAttachment,
    createColumnDatetime,
    createColumnInput
} from "../../../../components/table/c-table.logic";
import i18n from "../../../../i18n";
import { putField } from "../../../../utils/form";
import { download } from "../../../../utils/file";

export const createColumns = () => {
    const columns = [
        createColumnDatetime({
            title: () => i18n.global.t("views.ktb-payment-output-file.updateDate"),
            dataIndex: "updateDate",
            align: "center",
            search: { visible: () => false }
        }),
        createColumnInput({
            title: () => i18n.global.t("views.ktb-payment-output-file.name"),
            dataIndex: "name",
            align: "center",
            // search: { visible: () => false }
        }),
        createColumnAttachment({
            title: () => i18n.global.t("views.ktb-payment-output-file.textFile"),
            dataIndex: "path",
            align: "center",
            customRender: ({ record }) => {
                return (<a href="javascript:void(0)" onClick={() => download({ file: record })}><u>Download</u></a>);
            },
            sorter: false,
            width: 70,
        })
    ];
    return columns;
};

export const createField = ({ data }) => {
    return putField({
        data,
        fields: []
    });
};
